import {useEffect, useState} from "react";

import moment from "moment";
import {useStore} from "../../../../../../hooks/useStore";
import {useFetch} from "../../../../../../hooks/useFetch";

export const useCourierWalletInvoiceSubTab = ({courier, canRender = false}) => {
    const stores = useStore();
    const DEFAULT_DATE_RANGE = [moment().subtract(7, "day"), moment()];
    const [dateRange, setDateRange] = useState(DEFAULT_DATE_RANGE);

    const [selectedPaymentInvoice, setSelectedPaymentInvoice] = useState(null);

    const [paymentInvoicesResultLoading, paymentInvoicesResult] = useFetch({
        fetchFn: stores.walletStore.getCourierPaymentInvoices.bind(null, {
            courierId: courier?._id,
            startDate: dateRange?.[0]?.format("YYYY-MM-DD"),
            endDate: dateRange?.[1]?.format("YYYY-MM-DD")
        }),
        dependencies: [courier?._id, JSON.stringify(dateRange), canRender],
        initialCall: canRender,
        condition: Boolean(courier?._id) && Boolean(courier?.isWalletActive) && canRender
    });

    useEffect(() => {
        resetSelectedPaymentInvoice();
        resetDateRange();
    }, [canRender]);

    const resetSelectedPaymentInvoice = () => {
        setSelectedPaymentInvoice(null);
    };

    const handleDateRangeChange = async dates => {
        resetSelectedPaymentInvoice();
        if (!dates || !dates[0] || !dates[1]) {
            setDateRange(null);
            return;
        }

        setDateRange([moment(dates[0]), moment(dates[1])]);
    };

    const resetDateRange = () => {
        handleDateRangeChange(DEFAULT_DATE_RANGE);
    };

    const handlePaymentInvoiceSelect = paymentInvoiceId => {
        const item = paymentInvoicesResult?.invoices?.find(
            invoice => invoice?._id?.toString() === paymentInvoiceId?.toString()
        );

        setSelectedPaymentInvoice(item);
    };

    return {
        paymentInvoicesResultLoading,
        paymentInvoices: paymentInvoicesResult?.invoices || [],
        selectedPaymentInvoice,
        selectedDateRange: dateRange,
        handleDateRangeChange,
        handlePaymentInvoiceSelect
    };
};
